
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.583 19.25c-.504 0-.936-.18-1.295-.538a1.768 1.768 0 01-.538-1.295V4.583c0-.504.18-.936.538-1.295.36-.359.791-.538 1.295-.538h3.85c.199-.55.531-.993.998-1.33A2.617 2.617 0 019 .918c.58 0 1.104.168 1.57.504.466.336.798.779.997 1.329h3.85c.504 0 .936.18 1.295.538.359.36.538.791.538 1.295v12.834c0 .504-.18.935-.538 1.295-.36.359-.791.538-1.295.538H2.583zm1.834-3.667h6.416V13.75H4.417v1.833zm0-3.666h9.166v-1.834H4.417v1.834zm0-3.667h9.166V6.417H4.417V8.25zM9 3.896a.668.668 0 00.688-.688.67.67 0 00-.195-.493A.67.67 0 009 2.521a.667.667 0 00-.688.687.665.665 0 00.688.688z"}})])
          )
        }
      }
    